<app-header></app-header>

<div class="heigh"></div>

<div class="container">
  <div class="row">
    <div class="text-center mb-4">
      <h1 class="fw-bolder page-title">BLOGS</h1>
    </div>
  </div>

  <div class="row">
    <!-- Blog Articles -->
    <div class="col-md-8">
      <ng-container *ngFor="let item of AllArticleDetails">
        <div class="my-4 article-card d-flex align-items-start " [routerLink]="['/blog', item.slug]">
          <div class="">
            <img class="img-fluid " 
                 [src]="item.thumbnail ? storageUrl + '/' + item.thumbnail : 'assets/images/fallback.webp'" 
                 alt="Article Image">
          </div>
          <div class="col-md-9 ps-3">
            <h2 class="article-title">{{ item.title }}</h2>
            <p class="content" [innerHTML]="item.meta_description"></p>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Sidebar Area -->
    <div class="col-md-4">
      <div class="">
        <!-- Featured Blogs Section -->
        <div class="sidebar-section mb-4">
          <h3 class="sidebar-title text-center border-bottom pb-2">Latest Blogs</h3>
          <ul class="featured-blogs-list list-unstyled mt-3">
            <li *ngFor="let item of latestFive">
              <a [routerLink]="['/blog', item.slug]" class="featured-blog-link">
                <span class="bullet">&#8226;</span> {{ item.title }}
              </a>
            </li>
          </ul>
        </div>

        <!-- Blog Categories Section -->
        <div class="categories-section mb-4 p-3 border rounded shadow-sm">
  <h3 class="categories-title text-center border-bottom pb-2">Categories</h3>
  <ul class="category-list mt-2 ps-0">
    <li *ngFor="let category of blogCategories" class="list-unstyled">
      <a [routerLink]="['/blog/category', category.id]" class="category-item">
        {{ category.category_name }}
      </a>
    </li>
  </ul>
</div>

        <!-- Call to Action Section -->
        <div class="sidebar-section cta-section mb-4 text-center p-3 border rounded">
          <h4>Subscribe to Our Newsletter</h4>
          <p>Stay updated with the latest blog posts and news.</p>
          <button class="cta-button btn btn-primary mt-2">Coming Soon!</button>
        </div>

   
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
